import type { T_IconProps } from '@/types/Title';

export const MsIcon = ({ className, color }: T_IconProps) => (
  <svg
    viewBox='0 0 16 16'
    className={className}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ color }}
  >
    <path
      d='M8.00003 5.00033C8.6467 5.00033 9.1667 4.48033 9.1667 3.83366C9.1667 3.18699 8.6467 2.66699 8.00003 2.66699C7.35336 2.66699 6.83336 3.18699 6.83336 3.83366C6.83336 4.48033 7.35336 5.00033 8.00003 5.00033ZM9.33336 10.667V12.667C9.33336 13.0337 9.03336 13.3337 8.6667 13.3337H7.33336C6.9667 13.3337 6.6667 13.0337 6.6667 12.667V10.667H6.29336C5.82669 10.667 5.5067 10.2003 5.6667 9.76699L6.92003 6.41366C7.0867 5.96699 7.52003 5.66699 8.00003 5.66699C8.48003 5.66699 8.91336 5.96699 9.08003 6.41366L10.3334 9.76699C10.4934 10.2003 10.1734 10.667 9.7067 10.667H9.33336Z'
      fill='currentColor'
    />
  </svg>
);
